/**
 * Single platform probe for charts-core's hotkey DISPLAY strings (dispatch
 * matches on e.code/altKey and never needs this). macOS renders Option-glyph
 * chords (⌥H); everything else renders Alt+H.
 */
export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false
  return /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent)
}
